

























































































































































































































































import {
    computed,
    defineComponent,
    onMounted,
    PropType,
    ref,
} from '@vue/composition-api';
import { detailApiApply, getAppInfo, updateCallbackUrl } from '@/apis/controll';
import { ApiInfoStatus, Status } from '@/type/enums';
import appSecret from '../app-secret.vue';
import imgUpload from '@/components/img-upload/index.vue';
import entry, { UploadImageStatus } from '@/components/entry/index.vue';
import { updateWebBasic, updateWebExtra } from '../../service';
import { skipLoadingWrapper } from '@/utils/helper';
import callbackUrl from '../callbackUrl.vue';
import { ZFormRoot } from '@ks/z-form';
import {
    handleErrorMessageToast,
    handleSuccessMessageToast,
} from '@/common/util';
import { ConfTable } from '@/components/table/table';
import { columns } from '../mobile/scope';

export default defineComponent({
    name: 'web-detail',
    props: {
        list: {
            type: Object as PropType<Record<string, any>>,
            required: true,
        },
        apiInfos: {
            type: Array as PropType<Record<string, any>>,
            default: () => {
                return [];
            },
        },
    },
    model: {
        prop: 'list',
        event: 'update',
    },
    components: {
        appSecret,
        imgUpload,
        entry,
        callbackUrl,
        ConfTable,
    },
    setup(props, context) {
        const apiInfoStatus: any = ApiInfoStatus;
        const status = Status;
        const bigImgSrc = ref('');
        const isEditBase = ref(false);
        const isEditOther = ref(false);
        const isBaseEditDisable = ref(false);
        const registerTable = ref([]);

        const appId = computed(() => {
            return context.root.$route.params.appId;
        });

        const validRegisterTable = computed(() => {
            return registerTable.value.filter(
                (item: any) => item.status === UploadImageStatus.success,
            );
        });

        const isShowApiInfo = computed(() => {
            return (
                props.list.status !== status.pending &&
                props.list.status !== status.fail
            );
        });

        const isAppEditDisable = computed(() => {
            return (
                isBaseEditDisable.value || props.list.updateApprovalStatus === 1
            );
        });

        function updateRegisterTable() {
            registerTable.value = props.list.appRegistration.map(
                (item: any, index: number) => {
                    return {
                        url: item,
                        name: `registration${index}`,
                        status: UploadImageStatus.success,
                    };
                },
            );
        }

        function previewImg(e: Event) {
            const img = e.target;
            bigImgSrc.value = (img as HTMLImageElement).src;
        }

        function closeBigImg(e: Event) {
            const target = e.target;
            if ((target as HTMLElement).tagName.toLocaleLowerCase() !== 'img') {
                bigImgSrc.value = '';
            }
        }

        async function handleDetailSelfApiApply(index: number) {
            try {
                const curinfo = props.apiInfos[index];
                const res: any = await detailApiApply(
                    appId.value,
                    curinfo.scopeGroupId,
                );
                if (res.data.result === 1) {
                    context.root.$message({
                        type: 'success',
                        message: '您的申请已提交',
                        customClass: 'message-custom message-success-custom',
                        iconClass: 'message-success-custom-icon',
                    });
                    curinfo.status = apiInfoStatus.applying;
                } else {
                    context.root.$message.error(
                        res.data.error_msg || '请求出错，请重试',
                    );
                }
            } catch (e) {
                context.root.$message.error('服务器错误');
            }
        }
        const detailSelfApiApply = skipLoadingWrapper(handleDetailSelfApiApply);
        const canBaseSubmit = computed(() => {
            return (
                props.list.name &&
                props.list.desc &&
                validRegisterTable.value.length &&
                props.list.icon
            );
        });
        const canOtherSubmit = computed(() => {
            return props.list.website && props.list.redirectUri;
        });
        async function refresh() {
            const res: any = await getAppInfo(appId.value);
            if (res.data.result === 1) {
                return res.data.appInfo;
            }
            context.root.$message({
                type: 'error',
                message: res.data.error_msg || '数据更新失败，请重试',
                customClass: 'message-custom message-error-custom',
                iconClass: 'message-error-custom-icon',
            });
            return {};
        }
        async function cancelEditBase() {
            isEditBase.value = false;
            const refreshInfo = await refresh();
            props.list.name = refreshInfo.name;
            props.list.desc = refreshInfo.desc;
            props.list.icon = refreshInfo.icon;
            props.list.appRegistration = refreshInfo.appRegistration;
            updateRegisterTable();
        }
        async function cancelEditOther() {
            isEditOther.value = false;
            const refreshInfo = await refresh();
            props.list.website = refreshInfo.website;
            props.list.webDownUrl = refreshInfo.webDownUrl;
            props.list.redirectUri = refreshInfo.redirectUri;
        }

        async function handleUpdateBase() {
            if (!canBaseSubmit.value) {
                return;
            }
            const res = await updateWebBasic({
                appId: appId.value,
                name: props.list.name,
                icon: props.list.icon,
                desc: props.list.desc,
                appRegistration: validRegisterTable.value.map(
                    (item: any) => item.url,
                ),
            });
            if (res.data.result === 1) {
                context.root.$message({
                    type: 'success',
                    message: '提交审核成功',
                    customClass: 'message-custom message-success-custom',
                    iconClass: 'message-success-custom-icon',
                });
                props.list.appRegistration = validRegisterTable.value.map(
                    (item: any) => item.url,
                );
                isBaseEditDisable.value = true;
                isEditBase.value = false;
                return;
            }
            context.root.$message({
                type: 'error',
                message: res.data.error_msg || '提交失败，请重试',
                customClass: 'message-custom message-error-custom',
                iconClass: 'message-error-custom-icon',
            });
        }

        const updateBase = skipLoadingWrapper(handleUpdateBase);

        async function updateOther() {
            if (!canOtherSubmit.value) {
                return;
            }
            const res: any = await updateWebExtra({
                appId: appId.value,
                website: props.list.website,
                webDownUrl: props.list.webDownUrl,
                redirectUri: props.list.redirectUri,
            });
            if (res.data.result === 1) {
                context.root.$message({
                    type: 'success',
                    message: '保存成功',
                    customClass: 'message-custom message-success-custom',
                    iconClass: 'message-success-custom-icon',
                });
                isEditOther.value = false;
                return;
            }
            context.root.$message({
                type: 'error',
                message: res.data.error_msg || '保存失败，请重试',
                customClass: 'message-custom message-error-custom',
                iconClass: 'message-error-custom-icon',
            });
        }

        onMounted(() => {
            updateRegisterTable();
        });

        const isEditPush = ref(false);
        const pushForm = new ZFormRoot(() => ({
            callbackUrl: '',
            taskId: '',
        }));

        onMounted(() => {
            pushForm.initialValue = () => ({
                taskId: '',
                callbackUrl: props.list.callbackUrl,
            });
            pushForm.reset();
        });

        function cancelPushForm() {
            isEditPush.value = false;
            context.root.$nextTick(() => {
                pushForm.reset();
            });
        }
        async function savePushForm() {
            if (!pushForm.canSubmit) return;
            pushForm.validate().then((err) => {
                const { callbackUrl, taskId } = pushForm.value;
                if (err.length === 0) {
                    updateCallbackUrl(callbackUrl, appId.value, taskId)
                        .then((res) => {
                            if (res.data.result !== 1) {
                                handleErrorMessageToast(
                                    res.data.error_msg || '保存失败，请重试',
                                );
                                return;
                            }
                            props.list.callbackUrl = callbackUrl;
                            pushForm.initialValue = () => ({
                                taskId: '',
                                callbackUrl: callbackUrl,
                            });
                            cancelPushForm();
                            handleSuccessMessageToast('保存成功');
                        })
                        .catch(() => {
                            handleErrorMessageToast('服务器错误');
                        });
                }
            });
        }

        return {
            status,
            previewImg,
            closeBigImg,
            isShowApiInfo,
            appId,
            bigImgSrc,
            apiInfoStatus,
            isEditBase,
            isEditOther,
            isAppEditDisable,
            cancelEditBase,
            cancelEditOther,
            canBaseSubmit,
            canOtherSubmit,
            updateBase,
            updateOther,
            registerTable,
            isEditPush,
            pushForm,
            cancelPushForm,
            savePushForm,
            columns: columns(detailSelfApiApply),
        };
    },
});
